import { Mail } from "lucide-react";
import { EMAIL, Reveal } from "./booking";

export default function Careers() {
  return (
    <section
      id="careers"
      data-testid="careers-section"
      className="px-5 lg:px-12 py-16 lg:py-24 border-t border-border bg-card"
    >
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
        <Reveal>
          <p className="overline mb-4">Careers</p>
          <h2 className="font-display uppercase leading-[0.9] text-4xl sm:text-5xl lg:text-6xl max-w-2xl">
            We're always looking for talented barbers who take pride in their craft.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <a
            href={`mailto:${EMAIL}?subject=Joining%20Faded%20Barber%20Co.`}
            data-testid="careers-contact-button"
            className="btn-primary"
          >
            <Mail size={16} aria-hidden="true" /> Interested in joining Faded? Contact us
          </a>
        </Reveal>
      </div>
    </section>
  );
}
